<template>
    <div>
        <b-form-group label="Comparison"
                      label-size="sm"
                      :label-cols-sm="1">
            <b-form-select
                size="sm"
                v-model="value.comparison"
                :options="store.discountActivations"
                value-field="name"
                text-field="name">
            </b-form-select>
        </b-form-group>
        <b-form-group label="Then"
                      label-size="sm"
                      :label-cols-sm="1">
            <b-form-select
                size="sm"
                v-model="value.then"
                :options="store.discountActivations"
                value-field="name"
                text-field="name">
            </b-form-select>
        </b-form-group>
        <b-form-group label="Else"
                      label-size="sm"
                      :label-cols-sm="1">
            <b-form-select
                size="sm"
                v-model="value.else"
                :options="store.discountActivations"
                value-field="name"
                text-field="name">
            </b-form-select>
        </b-form-group>
    </div>

</template>

<script>
import valueCmp from "./mixins/valueCmp";

export default {
    mixins: [valueCmp]
}
</script>

<style scoped>

</style>
